import { module } from "angular";
import ngRedux from "ng-redux";
import assignees from "@gtmhub/assignees/module";
import employeeCore from "@gtmhub/employees/employees-core.module";
import env from "@gtmhub/env/env.module";
import errorHandling from "@gtmhub/error-handling/module";
import favorites from "@gtmhub/favorites/favorites.module";
import featureToggles from "@gtmhub/featureToggle/module";
import profile from "@gtmhub/profile/profile.module";
import users from "@gtmhub/users/users.module";
import { EmployeeProfileComponent } from "./components/employee-profile/employee-profile.component";
import { EmployeesCtrl } from "./controllers/employees";

const mod = module("employees", [employeeCore, errorHandling, ngRedux, assignees, users, env, featureToggles, profile, favorites]);

mod.component("employeeProfile", EmployeeProfileComponent);
mod.controller("EmployeesCtrl", EmployeesCtrl);

export default mod.name;
